export interface ITaskResultProps {
  taskId: string
  taskType: string
  response: Record<string, any>
  unReadCount: number
  messageTitle?: string
  messageNotifyCount?: number
}

// 批量未读信息
export interface ResponseUnReadType {
  messageCount: number
  exportCount: number
  taskResults: ITaskResultProps[]
}

// 消息已读
export interface MessageReadType {
  msgSeq: string
}

export interface MessageItemType {
  msgSeq: string // 消息id
  receiverId: string // 	接收通知用户id
  msgSourceId: string // 	通知来源所有者id
  msgSource: MsgResourceType // 	通知来源
  msgTitle: string // 通知标题，本期前端根据ext字段拼接冗余未来使用。
  msgBody: string // 通知体，本期前端根据ext字段拼接 冗余未来使用。
  read: boolean // 已读
  createTime: number //创建时间
  extInfo: MessageItemExtInfo
}

// CREATE_USER 新建用户 BATCH_CREATE 批量新建 BATCH_CREATE_DELIVER 批量新建并发货 BATCH_UPDATE_DELIVER 批量更新并发货 BATCH_CANCEL 批量取消 UPDATE_DELIVER 单个更新并发货 CREATE_DELIVER 单个创建并发货
export type MsgResourceType =
  | 'CREATE_USER'
  | 'BATCH_CREATE'
  | 'BATCH_CREATE_DELIVER'
  | 'BATCH_UPDATE_DELIVER'
  | 'BATCH_CANCEL'
  | 'UPDATE_DELIVER'
  | 'CREATE_DELIVER'
  | 'STORE_UNBIND'
  | 'STORE_BIND'
  | 'STORE_PULL_ORDER'
  | 'PULL_ORDER'
  | 'CANCEL_DELIVER'
  | 'UPDATE_REMARK'

export interface MessageItemExtInfo {
  status: string // 状态 SUCCESS 成功 FAIL失败
  totalNum: number // 总数
  submitSuccessNum: number // 提交成功
  submitFailNum: number // 提交失败
  sendNum: number // 发货总数量
  succeedNum: number // 成功数量
  failedNum: number // 失败数量
  oneshipNo: string // 订单号
  bulkNo: string // 批次号
  appId: string // 平台
  orderNo: string // 订单号
  submitTime: string // 拉单任务提交时间
  fileUrl: string | null // 错误url
  sourceCountry?: string // 消息的来源国家地区
  payOrderDetailId?: string // 运费纠正流水号
}

export interface TaskType {
  taskInfo: {
    pageNum: number
    list: ITaskInfo[]
    hasNext: boolean
    socketData?: ITaskInfo[]
  }
  unReadTaskCount: number
  /** 打开任务中心 */
  isOpen: boolean
}

export interface ITaskInfo {
  /** 任务id */
  batchTaskId: string

  taskStatus: 0 /**待处理*/ | 1 /**处理中*/ | 2 /**处理失败*/ | 3 /**部分失败*/ | 4 /**成功 */
  taskType:
    | 'product_import' /**商品导入*/
    | 'order_intercept' /**批量拦截订单*/
    | 'order_import' /**批量拦截订单*/
    | 'order_split' /**批量拆单 */
    | 'order_split_cancel' /**批量取消拆单 */
  /** 商家ID */
  sellerId: string
  /** 是否已读 */
  read: boolean
  /** 创建时间 */
  createTime: number
  /** 是否超过90天 */
  isOverTime: boolean

  taskData: {
    /** 失败记录文件地址 */
    failFileUrl: string
    /** 失败行数 */
    failedCount: number
    /** 文件类型 .xls .xlsx .csv */
    fileType: string
    /** 源文件地址 */
    originFileUrl: string
    /** 成功行数 */
    succeedCount: number
    totalCount: number
    timeout: number
    /**出库失败的id */
    failedOutboundIds?: string[]
    /**出库单id */
    outboundOrderIds?: string[]

    // 批量订单出库的字段不同，坑货
    /** 成功行数 */
    successCount: number
    /** 失败行数 */
    failCount: number
    // 成功原因
    successInfos?: ISuccessInfo[]
    /**已处理的订单 */
    processedOutboundOrderIds?: string[]
    failInfos?: IFailInfo[]
    fileUrl?: string
    stockAdjustId?: string
    enabled?: boolean
    // todo: 删除，仅用于测试
    skuResultDOS?: any
    action?: string
    /** 任务标签 */
    flags?: string[]
    onlySyncSkuMapping?: boolean
  }
}

export interface IFailInfo {
  //失败原因
  outboundFailInfos: IFailInfoItem[]
  refundFailInfos?: IFailInfoItem[]
  /** 订单号 */
  orderShortId: string
  // 退货单号
  refundOrderId?: string
  //失败单号
  outboundOrderId: string
  //消息如果没有outboundFailInfos，可以考虑使用这个字段
  message?: string

  /** 批量启用/停用 */
  fail?: string
  skuId?: string
  result?: boolean

  /** 店铺名称 */
  storeName?: string
  /** 商品名称 */
  skuName?: string
  /** 错误码 */
  code?: string
  /** 错误原因 */
  reason?: string
  /** 平台 */
  source?: string
}

export interface IStockSyncTaskData {
  batchTaskId: string
  taskData: {
    failCount: number
    failInfos: {
      failCode: string
      failMsg: string
      skuId: string
      skuInfoId: string
      source: string
      storeId: string
      storeName: string
      storeSeq: string
    }[]
    successCount: number
    stockSyncType: string
    stockSyncCalculateReq: {
      stockAllocateMode: 'exclusive' | 'shared'
      operateType: number
    }
  }
}

export interface ISuccessInfo {
  //单号
  outboundOrderId: string
  //短号
  orderShortId: string
}

export interface IFailInfoItem {
  failReason: string
  failData: any
}

export interface ITaskListResponse {
  pageNum: number
  hasNext: boolean
  list: ITaskInfo[]
}

export interface ICountOfUnreadResponse {
  unReadCount: number
}

export interface ITaskBase {
  /**任务标题 */
  title: string
  /**任务描述 */
  desc?: string
  /**已读状态 */
  read: boolean
  /**创建时间 */
  createTime: number
  taskStatus: 0 /**待处理*/ | 1 /**处理中*/ | 2 /**处理失败*/ | 3 /**部分失败*/ | 4 /**成功 */ | 5 /** 已重试 */
  taskType?: string
  /** 任务id */
  batchTaskId?: string
  /** 失败行数 */
  failedCount?: number
  /** 成功行数 */
  succeedCount?: number
  /** 支持的数量 */
  supportCount?: number
  /** 源文件地址 */
  originFileUrl?: string
  /** 失败记录文件地址 */
  failFileUrl?: string
  totalCount?: number
  // 失败原因
  failInfos?: IFailInfo[]
  // 成功原因
  successInfos?: ISuccessInfo[]
  /**已处理的订单 */
  processedOutboundOrderIds?: string[]

  /** 是否超过90天 */
  isOverTime?: boolean
  taskData?: {
    fileUrl?: string
  }

  outboundOrderIds?: string[]
  orderMcIds?: string[]

  createCount?: number
  updateCount?: number
  createFailCount?: number
  updateFailCount?: number

  // 标记批量操作的类型
  // true: 启用， false：停用
  enabled?: boolean
  /**修改动作 */
  action?: string
  /** 任务标签 */
  flags?: string[]
}

export enum StatusEnum {
  /** 待处理 */
  PENDING = 0,
  /** 处理中 */
  PROCESSING = 1,
  /** 处理失败 */
  ALL_FAILURE = 2,
  /** 部分失败 */
  PARTIAL_FAILURE = 3,
  /** 成功 */
  SUCCESS = 4,
}
